import { Component, Input, OnInit } from '@angular/core';
import { error } from 'protractor';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
  selector: 'app-dado-empresa-endereco',
  templateUrl: './dado-empresa-endereco.component.html',
  styleUrls: ['./dado-empresa-endereco.component.scss']
})
export class DadoEmpresaEnderecoComponent implements OnInit {

    private currentUser: Auth;
    public address: any;

    @Input() addressTypeId: number;

    constructor(
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private cedenteService: CedenteService
    ) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.getAddress(this.addressTypeId);
    }

    getAddress(addressTypeId: number){
        this.cedenteService.getAddress(this.currentUser.token.assignorGuid, addressTypeId).subscribe(
            response => {
                this.address = response.result;
            }, error => {
                this.alertService.error(error.message);
            }
        );
    }

}
